import React, { useEffect, useState, useRef } from "react";
import ImageComponent from "../../components/newQuestionApproveComps/imageComponent";
import SubCourses from "../../components/newQuestionApproveComps/subCourses";
import {
  getQuestionById,
  updateQuestion,
} from "../../api/QuestionSubCourseSelection/courses";
import { ToastContainer, toast } from "react-toastify";
import SideBar from "../../components/SideBar";
import { useMediaQuery } from "react-responsive";
import { Components } from "../../assets/Dimensions";
import ExamType from "../../enums/ExamType";
import NavigationType from "../../enums/NavigationType";
import "./style.css";
import { GetObjectKey } from "../../helpers/getObjectKeyFromValue";
import MenuIcon from "@material-ui/icons/Menu";
import Loader from "@material-ui/core/CircularProgress";
import { useHistory } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import QuestionReportModal from "../../components/ReportModal/Components/Modal/Modal";
import AdminPanelPage from "../../enums/AdminPanelPage";
import { useReportIssues } from "../../hooks/useReportIssue";
import {
  getReviewQuestions,
  updatequestioncontenttype,
} from "../../api/BookSectionCrop";
import ResponseStatus from "../../enums/ResponseStatus";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
import IconButton from "@material-ui/core/IconButton";
import QuestionReportsModal from "./components/QuestionReportsModal";
import ContentType from "../../enums/ContentType";
import QuestionProcessLogsModal from "../../components/QuestionProcessLogsModal/QuestionProcessLogsModal";
import TaskStatus from "../../enums/TaskStatus";

const QuestionPage = (props) => {
  const subCoursesRef = useRef(null);
  const {
    courseId,
    courseName,
    topicName,
    SegmentTopicId,
    subTopicName,
    classTypeId,
    contentType,
    segmentId,
    allSegmentData,
  } = props.location.state;
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const userAdminToken = sessionStorage.getItem("jwtP");
  const isTabletOrMobile = useMediaQuery({ query: "(max-width: 700px)" });
  const [selectedSubTopic, setSelectedSubTopic] = useState(null);
  const [questionData, setQuestionData] = useState(null);
  const [nav, setNav] = useState(false);
  const [nestedTitles, setNestedTitles] = useState(null);
  const [noTopicModal, setNoTopicModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [showQuestionReportsModal, setShowQuestionReportsModal] =
    useState(false);
  const [questionSelectedTopicsData, setQuestionSelectedTopicsData] =
    useState(null);
    const [showLogs, setShowLogs] = useState(false);
    const [logsMode, setLogsMode] = useState("view");
    
    const [resetSelectionKey, setResetSelectionKey] = useState(0);


  const [changedQuestionPropeties, setChangedQuestionPropeties] = useState({
    courseName: null,
    topicName: null,
    subTopicName: null,
    achievementName: null,
  });

  const getExamTypeName = (value) => {
    for (const key in ExamType) {
      if (ExamType[key] === value) {
        return key;
      }
    }
    return null; // Return null if the value is not found
  };

  const style = {
    container: {
      //state e bool değer ekle menü butonuna basıldığında css
      //içinde container a margin eklesin hemde navı açsın

      //marginLeft: isTabletOrMobile ? 0 : Components.SideBarWidth + 15,
      paddingLeft: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,

      paddingRight: 15,
      marginBottom: 50,
      marginTop: "1rem",
    },
    editIcon: {
      width: Components.Image.Big.Width,
      height: Components.Image.Big.Height,
    },
    iconButton: {
      marginLeft: 10,
      padding: 0,
    },
  };

  const previousQuestion = () => {
    getQuestion(NavigationType.Previous);
  };
  const nextQuestion = () => {
    getQuestion(NavigationType.Next);
  };
  const updateQuestionInfo = async (id, contentType, TaskStatus,Comment) => {
    setLoader(true);
    try {
      const payload = {
        Id: id,
        ContentType: contentType,
        CMS_BSCTopicId: questionData.CMS_BSCTopicsId,
        ...(TaskStatus !== undefined && { CMSStatus: TaskStatus }),
        Comment:Comment
      };
      const res = await updatequestioncontenttype(payload, user.Token);
      if (res.data.ResponseStatus === 1) {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      toast.error("Bir hata oluştu lütfen yetkililere ulaşınız");
      setTimeout(() => {
        history.goBack();
      }, 2000);
    } finally {
      setLoader(false);
    }
  };

  const {
    issueTypes,
    reportModal,
    openReportModal,
    onReportSubmit,
    setIssueTypes,
    setReportModal,
  } = useReportIssues(user.Token, questionData, updateQuestionInfo);

  const getSelectedSubTopic = (item) => {
    setSelectedSubTopic(item);
  };

  const getQuestion = async (Navigation) => {
    setLoader(true);
    try {
      const payload = {
        Id:
          contentType === ContentType.SubCourseTopic
            ? SegmentTopicId
            : courseId,
        NavigationType: Navigation || NavigationType.Default,
        ContentType: contentType,
        CMS_BSCTopicId: questionData?questionData.CMS_BSCTopicsId : 0
      };
      const res = await getReviewQuestions(payload, user.Token);
      if (res.data.ResponseStatus === ResponseStatus.Success) {
        setResetSelectionKey(k => k + 1);
        if (subCoursesRef.current) {
          subCoursesRef.current.resetDropdownStates();
        }
        setQuestionData(res.data.ResponseData);
        setLoader(false);
        setQuestionSelectedTopicsData(res.data.ResponseData);
        // getQuestionSelectedInfo(res.data.ResponseData.CMS_BSCTopics_Id);
      } else if (res.data.ResponseStatus === ResponseStatus.DataIsNull) {
        setLoader(false);
        toast.error(res.data.ResponseMessage);
        // setTimeout(() => {
        //   history.goBack();
        // }, 2000);
      } else if (res.data.ResponseStatus === ResponseStatus.Error) {
        if (subCoursesRef.current) {
          subCoursesRef.current.resetDropdownStates();
        }
        toast.error(res.data.ResponseMessage);
        setTimeout(() => {
          history.goBack();
        }, 2000);
      } else {
        setLoader(false);
        toast.error("Bir hata oluştu lütfen yetkililere ulaşınız");
        setTimeout(() => {
          history.goBack();
        }, 2000);
      }
    } catch (error) {
      setLoader(false);
      toast.error("Bir hata oluştu lütfen yetkililere ulaşınız");
      setTimeout(() => {
        history.goBack();
      }, 2000);
    }
  };

  const handleLabelsUpdate = (labels) => {
    setChangedQuestionPropeties(labels);
    // You can store it in state, send it to API, etc.
  };

  useEffect(() => {
    getQuestion();
  }, []);

  // const fetchLogs = async () => {
  //   try {
  //     setLoader(true);
  
  //     // TODO - Replace with real API
  //     // const res = await getQuestionProcessLogs(questionData.BookSectionCropId, user.Token);
  
  //     // setLogs(res.data.ResponseData); // Assuming this is the structure
      
  //     const dummyResponse = [
  //       {
  //         SegmentTopicId: 0,
  //         CourseName: "Matematik",
  //         CourseTopicName: "Fonksiyonlar",
  //         SubCourseTopicName: "Limit",
  //         Status: 5,
  //         CreatedDate: "2025-01-10T12:31:00",
  //         Comment: "İlk işlem kaydı"
  //       },
  //       {
  //         SegmentTopicId: 10203,
  //         CourseName: "Matematik",
  //         CourseTopicName: "Türev",
  //         SubCourseTopicName: "Türev Alma",
  //         Status: 6,
  //         CreatedDate: "2025-01-11T09:45:00",
  //         Comment: "Yanlış konuya atanmış"
  //       }
  //     ];
  //     setLogs(dummyResponse);
  //     setShowLogs(true);
  //   } catch (e) {
  //     toast.error("Log bilgisi alınamadı");
  //   } finally {
  //     setLoader(false);
  //   }
  // };
  

  return (
    <>
      {isTabletOrMobile ? (
        <div>
          <MenuIcon
            onClick={() => {
              setNav(!nav);
            }}
            style={{
              position: "absolute",
              top: 10,
              right: 10,

              cursor: "pointer",
              pointerEvents: "auto",
            }}
          />

          {nav && <SideBar />}
        </div>
      ) : (
        <SideBar />
      )}

      <ToastContainer />
      <div style={style.container}>
        {questionData && (
          <div
            style={{
              position: "relative",

              display: "flex",
              flexDirection: "column",
              top: 0,
              //left: isTabletOrMobile ? 15 : Components.SideBarWidth + 15,
            }}
          >
            <button
              style={{
                display: "flex",
                justifyContent: "flex-start",
                alignItems: "center", // Ensure the content is vertically centered
                width: "20%", // Make sure the button takes up full width
              }}
              onClick={() => {
                history.goBack();
              }}
              className="prevButton"
            >
              <ArrowBackIcon />
              Geri Dön
            </button>
            {/* kpss kontrolü eklenmesinin bu soruların couse nameleri aslında genel olduğu için buyüzden gösterimde yanlış course name altında olmasından dolayı  */}
            <div style={styles.gridContainer}>
              {/* Column 1 - Original Source */}
              <div style={styles.column}>
                <h4 style={styles.header}>Kaynak</h4>
                <div style={styles.text}>
                  {questionData.BookSectionCropId} -{" "}
                  {/* {GetObjectKey(examType, ExamType)} */}
                  <br />
                  {questionData.BookName} - {questionData.BookSectionName}
                  <br />
                  {questionData.OrginalCourseName} /{" "}
                  {questionData.OrginalCourseTopicName}
                  {questionData.OrginalCourseTopicName !==
                  questionData.OrginalSubCourseTopicName
                    ? ` - ${questionData.OrginalSubCourseTopicName}`
                    : ""}
                  <br />
                </div>
              </div>

              {/* Column 2 - Original Question Data */}
             { (questionData.CMSTopicStatus !== 4) && <div style={{ ...styles.column, backgroundColor: "green" }}>
                <h4 style={{ ...styles.text, color: "white" }}>
                  Yeni Seçilen Bilgiler
                </h4>
                <div
                  style={{
                    ...styles.text,
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <span>Ders: {questionData.CourseName}</span>
                  <span>Konu: {questionData.CourseTopicName}</span>
                  <span>Alt Konu: {questionData.SubCourseTopicName}</span>
                
                    <span>
                    Kazanım:{" "}
                    {questionData.AchievementId === -1
                      ? "Kazanımı yoktur."
                      : questionData.AchievementId === -2
                      ? "Çoklu kazanım."
                      : questionData.AchievementName}
                  </span>
                  
                 
                </div>
              </div>}

              {/* Column 3 - Updated Question Data */}
              {
                (questionData.CMSTopicStatus === 4) && (
                  <div style={{ ...styles.column, backgroundColor: "red",justifyContent:"center", alignItems:"center" }}>
                    <h4 style={{ ...styles.text, color: "white" }}>İçerik hedeflenen sınıfla uyumlu değildir.</h4>
                    
                  </div>
                )}
            </div>
          </div>
        )}

        {/* Loader container */}
        {loader && (
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Loader size={100} />
          </div>
        )}

        {reportModal && questionData && (
          <QuestionReportModal
            onClose={() => setReportModal(false)}
            responseData={issueTypes}
            setResponseData={setIssueTypes}
            isLoading={loader}
            onSubmit={onReportSubmit}
            adminPanelPage={AdminPanelPage.QuestionSubTopicSelection}
            BookSectionCropId={questionData.BookSectionCropId}
          />
        )}
        {showQuestionReportsModal && (
          <QuestionReportsModal
            reports={
              questionData.Reports && questionData.Reports.length
                ? questionData.Reports.flatMap((report) =>
                    report.Issues && report.Issues.length
                      ? report.Issues.map((issue) => ({
                          Message: report.Message || "",
                          Issiues: issue,
                        }))
                      : []
                  )
                : []
            }
            onClose={() => setShowQuestionReportsModal(false)}
          />
        )}

        {questionData && (
          <div>
            <div
              className="questionContainer"
              // style={{display:"flex",direction:"column",flexWrap: "wrap",gap:"5rem" }}
            >
              {noTopicModal && (
                <div className="modal">
                  <div className="modal-content">
                    <div style={{ textAlign: "center" }}>
                      <h2>
                        Konu Seçimi Yapmadınız Devam etmek istediğinize
                        Eminmisiniz?
                      </h2>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-around",
                        }}
                      >
                        <button
                          style={{ padding: 10, width: "30%" }}
                          onClick={() => {
                            setNoTopicModal(false);
                          }}
                        >
                          Vazgeç
                        </button>
                        <button
                          style={{ width: "30%" }}
                          onClick={() => {
                            setNoTopicModal(false);
                            getQuestion(questionData.TeacherOrder + 1);
                          }}
                        >
                          Devam Et
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {showLogs && (
                <QuestionProcessLogsModal
                  questionCmsId={questionData.CMS_BSCTopicsId}
                  mode={logsMode}
                  onClose={() => {
                    setResetSelectionKey((k) => k + 1);
                    setShowLogs(false);
                    setLogsMode("view");
                  }}
                  onConfirmReject={async (comment) => {
                    console.log("onConfirmReject");

                    await updateQuestionInfo(
                      undefined,
                      undefined,
                      TaskStatus.Reject,
                      comment
                    );

                    setShowLogs(false);
                    setLogsMode("view");
                    // 👇 navigate after reject update
                    nextQuestion();
                  }}
                  onAddNote={async (comment) => {
                    // ADD NOTE API HERE
                    await updateQuestionInfo(
                      undefined,
                      undefined,
                      undefined,
                      comment
                    );
                    console.log("NOTE ADDED:", comment);
                  }}
                />
              )}

              <div
                className="questionImage"
                style={
                  {
                    // Enable vertical scrollbar when content overflows
                    // Set the maximum height of the component to 100vh
                    //flex:70
                    // overflow:"auto",
                    // maxWidth:"40%",
                    // maxHeight:window.screen.height/1.5
                  }
                }
              >
                <ImageComponent
                  openReportModal={openReportModal}
                  // examTypeId={examType}
                  questionData={questionData}
                  setShowQuestionReportsModal={setShowQuestionReportsModal}
                  onShowLogs={() => {
                    setLogsMode("view");
                    setShowLogs(true);
                  }}
                />
              </div>
              {/* <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                }}
              >
                <button
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => previousQuestion()}
                  className="nav-btn"
                >
                  <ArrowBackIcon /> Önceki
                </button>
                <button
                  style={{ display: "flex", alignItems: "center" }}
                  onClick={() => nextQuestion()}
                  className="nav-btn"
                >
                  Sonraki <ArrowForwardIcon />
                </button>
              </div> */}
              <div
                className="topicsContainer"
                style={
                  {
                    // overflowY: "auto", // Enable vertical scrollbar when content overflows
                    // Set the maximum height of the component to 100vh
                    //flex:30
                    // overflow:"auto",
                    // maxWidth:"40%",
                    // height:"auto",
                    // maxHeight:"100vh"
                  }
                }
              >
                {questionSelectedTopicsData && (
                  <SubCourses
                    ref={subCoursesRef}
                    segmentId={segmentId}
                    // nestedTitlesData={nestedTitles}
                    classTypeId={classTypeId}
                    CourseId={courseId}
                    // examTypeId={examType}
                    getSelectedSubTopic={getSelectedSubTopic}
                    // questionDataExamType={questionData.ExamType}
                    // questionDataCourseId={questionData.CourseId}
                    nextQuestion={nextQuestion}
                    previousQuestion={previousQuestion}
                    questionData={questionData}
                    questionSelectedTopicsData={questionSelectedTopicsData}
                    updateQuestionInfo={updateQuestionInfo}
                    onLabelsUpdate={handleLabelsUpdate}
                    setLoader={setLoader}
                    loader={loader}
                    allSegmentData={allSegmentData}
                    onShowLogs={() => {
                      setLogsMode("reject");
                      setShowLogs(true);
                    }}
                    resetSelectionKey={resetSelectionKey}

                    // questionOrder={questionData.TeacherOrder}
                    // selectedSubTopic={questionData.NewSubCourseTopicUniqueId}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const styles = {
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gap: "16px",
    padding: "4px 0",
    alignItems: "flex-start",
    textAlign: "left",
    fontFamily: "sans-serif",
  },
  column: {
    background: "#f9fafb",
    borderRadius: "8px",
    padding: "4px",
    minHeight: "70px",
  },
  header: {
    fontSize: "12px",
    fontWeight: "600",
    marginBottom: "4px",
    color: "#1f2937",
  },
  text: {
    fontSize: "10px",
    color: "#374151",
    lineHeight: "1.4",
  },
};

export default QuestionPage;
